/*
 * This page will be displayed on the Audi Nemo site inside an iframe
 */

import React from 'react';
import {Helmet} from 'react-helmet';
import classnames from 'classnames';
import {Formik, Form} from 'formik';
import {validateSubscribe} from '../lib/validation';
import TextField from '../audi-ui-components/TextField';
import Select from '../audi-ui-components/Select';
import Button from '../audi-ui-components/Button';
import Spinner from '../audi-ui-components/Spinner';
import Checkbox from '../audi-ui-components/Checkbox';
import queryString from 'query-string';
import {
    DEFAULT_THEME,
} from '../constants';

class SubscribeForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            success: false,
            submitting: false,
            serverError: null,
            disclaimerOpen: false,
            makes: [
                {label: 'Audi', value: 'audi'},
                {label: 'BMW', value: 'bmw'},
                {label: 'Volkswagen', value: 'volkswagen'},
                {label: 'Mercedes Benz', value: 'mercedes-benz'},
            ]
        }
    }

    componentDidMount() {
        let q = queryString.parse(this.props.location.search);
        let theme = q.theme || DEFAULT_THEME;
        if (theme === "dark") {
            document.body.classList.add("theme-dark");
        }
        // get car makes
        fetch(
            `${process.env.RAZZLE_GQLAPI}`,
            {
                method: "POST",
                headers: {Accept: 'application/json', 'Content-Type': 'application/json', 'Cache-Control': 'no-cache'},
                body: JSON.stringify({
                    query: /* GraphQL */`query ($skip: Int, $take: Int) {
                        makersList(skip: $skip, take: $take) {
                            items {
                                value
                                label: name
                            }
                            totalCount
                        }
                    }`,
                    variables: {
                        skip: 0,
                        take: 50,
                    }
                }),
            }
        ).then((response) => {
            // console.log(response);
            if (response.status >= 400) {
                let error = new Error(response.statusText);
                error.response = response;
                error.status = response.status;
                throw error;
            }
            return response.json();
        }).then((res) => {
            // console.log(res);
            var opts = [...this.state.makes];
            opts.push({label: "──────────", value: "_", disabled: true});
            opts = opts.concat(res.data.makersList.items);
            this.setState({makes: opts});
        }).catch((error) => {
            console.log(error);
            //
        });
    }

    handleSubmit = (formData, actions) => {
        this.setState({submitting: true, serverError: null});
        var options = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Cache-Control': 'no-cache',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                formName: 'requestExperienceBrochure',
                payload: {...formData, optOut: !formData.optIn},
                variation: '1',
            }),
        };
        fetch(`${process.env.RAZZLE_MYAUDI_API}/1/form`, options).then((response) => {
            if (response.status >= 400) {
                let error = new Error(response.statusText);
                error.response = response;
                error.status = response.status;
                throw error;
            }
            return response;
        }).then((res) => {
            // success
            this.setState({success: true, submitting: false});
            if (dataLayer) {
                dataLayer.push({'event': 'formSubmitSuccess', 'formName': 'requestExperienceBrochure', ...formData});
            }
        }).catch((error) => {
            // fail
            console.log(error);
            var errorMessage = "There was a problem submitting the form";
            if (error.status.toString() === '400' && error.response) {
                error.response.json().then(errorJson => { console.log(errorJson);
                    if (errorJson.message) {
                        errorMessage = errorJson.message;
                    }
                    if (errorJson.modelState) {
                        var fieldErrors = {};
                        var errorKeys = Object.keys(errorJson.modelState);
                        for (let i=0; i<errorKeys.length; i++) {
                            let key = errorKeys[i];
                            fieldErrors[`${key}`] = errorJson.modelState[`${key}`][0];
                        }
                        actions.setErrors(fieldErrors);
                    }
                });
            }
            this.setState({submitting: false, serverError: errorMessage});
        });
    }

    render() {
        let q = queryString.parse(this.props.location.search);
        let theme = q.theme || DEFAULT_THEME;
        return (
            <div className={classnames("iframe-content iframe-form", {"center": q.align === "center"})}>
            <div className="iframe-content__inner">
                <Helmet>
                    <script>{`
                        var savedHeight = 0;
                        function sendHeight() {
                            var appHeight = document.getElementById('AppContainer').offsetHeight + 50;
                            if(appHeight !== savedHeight) {
                                savedHeight = appHeight;
                                var pxHeight = appHeight + "px";
                                var payload = { height : pxHeight, url: window.location.href };
                                window.parent.postMessage(JSON.stringify(payload), '*');
                            }
                        }
                        window.setInterval(sendHeight, 1000);
                    `}</script>
                </Helmet>

                {!this.state.success && <Formik
                    initialValues={{
                        firstName: "",
                        lastName: "",
                        emailAddress: "",
                        postCode: "",
                        currentModel: "",
                        optIn: false
                    }}
                    validate={validateSubscribe}
                    validateOnBlur={true}
                    onSubmit={this.handleSubmit}
                    render= {({values, errors, touched, setFieldTouched, setFieldValue, handleChange}) => (<Form>
                        <div className="mb-4">
                        <TextField name="firstName"
                            label="First name*"
                            value={values.firstName}
                            maxLength={100}
                            isInvalid={errors.firstName && touched.firstName}
                            invalidMessage={errors.firstName}
                            onChange= {(v, e) => { handleChange(e); }}
                            onBlur={() => { setFieldTouched('firstName'); }}
                            theme={theme === "dark" ? "light" : null}
                        />
                        </div>
                        <div className="mb-4">
                        <TextField name="lastName"
                            label="Last name*"
                            value={values.lastName}
                            maxLength={100}
                            isInvalid={errors.lastName && touched.lastName}
                            invalidMessage={errors.lastName}
                            onChange= {(v, e) => { handleChange(e); }}
                            onBlur={() => { setFieldTouched('lastName'); }}
                            theme={theme === "dark" ? "light" : null}
                        />
                        </div>
                        <div className="mb-4">
                        <TextField name="emailAddress"
                            label="Email*"
                            value={values.emailAddress}
                            isInvalid={errors.emailAddress && touched.emailAddress}
                            invalidMessage={errors.emailAddress}
                            onChange= {(v, e) => { handleChange(e); }}
                            onBlur={() => { setFieldTouched('emailAddress'); }}
                            theme={theme === "dark" ? "light" : null}
                        />
                        </div>
                        <div className="mb-4"><TextField name="postCode"
                            label="Postcode*"
                            value={values.postCode}
                            isInvalid={errors.postCode && touched.postCode}
                            invalidMessage={errors.postCode}
                            onChange={(v) => { var _v = v.replace(/\D/g, '').substring(0, 4); setFieldValue('postCode', _v); }}
                            onBlur={() => { setFieldTouched('postCode'); }}
                            theme={theme === "dark" ? "light" : null}
                        />
                        </div>
                        <div className="mb-4">
                        <Select name="currentModel"
                            label="What are you currently driving?"
                            value={values.currentModel}
                            options={this.state.makes}
                            onChange= {(v, e) => { handleChange(e); }}
                            theme={theme === "dark" ? "light" : null}
                        />
                        </div>
                        <div className="mb-4">
                        <Checkbox
                            name="optIn"
                            label="I would like to be contacted by Audi Australia with occasional communications on products, offers, news and events.*"
                            checked={values.optIn}
                            onChange={(v, e) => { setFieldValue('optIn', e.target.checked); }}
                            onBlur={() => { setFieldTouched('optIn'); }}
                            isInvalid={errors.optIn && touched.optIn}
                            invalidMessage={errors.optIn}
                            theme={theme === "dark" ? "light" : null}
                        />
                        </div>
                        {!this.state.submitting && <Button variant="primary" theme={theme === "dark" ? "light" : null} type="submit">Submit</Button>}
                        {this.state.submitting && <Spinner isContinuous />}
                        <p className="aui-small mt-3">All fields marked with * are mandatory.</p>
                        <div className="pt-4 data-collection">
                            <button
                                type="button"
                                className={`data-collection__toggle${this.state.disclaimerOpen ? ' is-open' : ''}`}
                                onClick={() => this.setState({ disclaimerOpen: !this.state.disclaimerOpen })}
                            >
                                See our Data Privacy statement here
                            </button>
                            {this.state.disclaimerOpen && (
                                <div className="aui-small py-3">
                                    Audi Australia, a division of Volkswagen Group Australia Pty Ltd, will collect, hold and use your personal information for the purpose(s) set out above. Audi may disclose your personal information to Dealers, related companies or third parties that provide us with services, including to overseas locations (such as Germany). If you consent, Audi and Audi Dealers may also use your personal information to send you communications concerning products, offers, news and events. Please note that Audi and Audi Dealers are separate organisations, and that Dealers will handle your information in accordance with their own privacy policies. Our Privacy Policy explains how you can request access to and the correction of your personal information and how you may make a privacy complaint to us. For full details, see our <a href="http://www.audi.com.au/privacypolicy" target="_blank" rel="noopener noreferrer" className="aui-textlink">Privacy Policy</a>.
                                </div>
                            )}
                        </div>
                    </Form>)}
                />}

                {this.state.success && <div className="aui-headline-4">Thanks for your request, we will keep you updated.</div>}
            </div>
            </div>
        );
    }
}

export default SubscribeForm;
